/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { Component } from 'react';
import { shape, string, bool, number } from 'prop-types';
import LazyLoad from 'react-lazyload';
import Shimmer from '../Shimmer/Shimmer';
import { prettyRenderFraction } from '../../pages/pip/pipApp/dimensions/Fractions';

class ProductPod extends Component {
  static formatPricing(price) {
    if (price === 'N/A' || price === '-1') {
      return 'N/A';
    }

    return `$${parseFloat(price).toFixed(2)}`;
  }

  renderSaleOrFeaturedBanner() {
    const {
      product: { IsOnSale, IsFeatured },
    } = this.props;

    if (IsOnSale) return <div className="gcc-tag gcc-tag-sale absolute f7 fw7 top-1 left-0">Sale</div>;

    if (IsFeatured) return <div className="gcc-tag gcc-tag-featured absolute f7 fw7 top-1 left-0">Featured</div>;

    return null;
  }

  renderPriceMessaging() {
    const {
      product: { IsOnSale, Price, Message, PercDiscount, StockSku, IsTieredPromo = false },
    } = this.props;

    if (StockSku) return null;

    const noDiscountAndPrice = PercDiscount === 0 && Price !== 'N/A';

    if (noDiscountAndPrice)
      return (
        <div>
          <small className="gcc-text f7">Starting At</small>
        </div>
      );

    const saleAndPrice = IsOnSale && Price !== 'N/A';

    if (IsTieredPromo) {
      return (
        <div className="flex flex-column">
          <small className="red b mb2 f7">{Message}</small>
          <small className="gcc-text mb1 f8">WITH MINIMUM PURCHASE</small>
        </div>
      );
    }

    if (saleAndPrice) {
      return (
        <div>
          <small className=" gcc-text strike f7">{ProductPod.formatPricing(Price)}</small>
          <small className="red b ml1 mb1 f7">{Message}</small>
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      product: { FinalPrice, Url, MediaUrl, Name, BrandName, Width, Height, Price },
    } = this.props;
    const hasFinalPrice = !(FinalPrice === 'N/A' || FinalPrice === '');
    const presentationHeight = prettyRenderFraction(Height, true);
    const presentationWidth = prettyRenderFraction(Width, true);

    return (
      <a
        href={Url}
        className="flex items-stretch"
        style={{ textDecoration: 'inherit', color: 'inherit' }}
        rel="nofollow"
      >
        <article
          className="gcc-prdwdg-mini gcc-box-1 mh3 flex flex-wrap flex-column mb2"
          style={{ minWidth: 185, maxWidth: 185, minHeight: 272 }}
        >
          <figure className="relative w-100">
            {this.renderSaleOrFeaturedBanner()}
            <LazyLoad offset={100} height={150} once>
              <img
                alt={Name}
                src={MediaUrl}
                width="185"
                className="br3 br--top"
                style={{ width: 185, height: 150, minHeight: 150 }}
              />
            </LazyLoad>
          </figure>
          <div className="w-100 flex-auto flex">
            <div className="flex flex-column w-100 ma2">
              <div className="gcc-text w-100 f7 lh-copy gray b">{BrandName}</div>
              <div className="w-100 flex-auto mb2">
                <div className="black f6 lh-title db">{Name}</div>
              </div>
              <div className="w-100 pb0 pb2-ns">
                <div className="flex flex-wrap justify-between">
                  <div className="w-100 f7 gray mb1">{this.renderPriceMessaging()}</div>
                  <div className="w-50 f4">
                    {hasFinalPrice ? ProductPod.formatPricing(FinalPrice) : ProductPod.formatPricing(Price)}
                  </div>
                  <div className="gcc-text w-50 tr lh-title flex self-end justify-end gray f7">
                    {presentationWidth}&quot;x{presentationHeight}&quot;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </a>
    );
  }
}

const ProductPodShimmer = () => (
  <div className="flex items-stretch" style={{ textDecoration: 'inherit', color: 'inherit' }}>
    <article
      className="gcc-prdwdg-mini gcc-box-1 mh3 flex flex-wrap flex-column mb2"
      style={{ minWidth: 185, maxWidth: 185, minHeight: 272 }}
    >
      <Shimmer height="100%" width="100%" className="br3" />
    </article>
  </div>
);

ProductPod.propTypes = {
  product: shape({
    MediaUrl: string,
    Name: string,
    Width: number,
    Height: number,
    BrandName: string,
    Url: string,
    Message: string,
    FinalPrice: string,
    IsOnSale: bool.isRequired,
    IsFeatured: bool.isRequired,
    StockSku: string,
  }).isRequired,
};

export default ProductPod;

export { ProductPod, ProductPodShimmer };
